import { apiCustomer, apiVehicle } from "../../../api/api-vehicle";
import {
  CAR_STATUS,
  TRANSMISSION_TYPE,
} from "../../../common/utils/static-data";
import { alert } from "../../../common/utils/alert";
import { emitter } from "../../../common/utils/emitter";
import moment from "moment";

export const submit = (
  context,
  isModal,
  visiableOkButtonOnModal,
  setCustomerOnModal
) => {
  context.form
    .validateFields()
    .then(async (values) => {
      if (!isModal) {
        emitter.emit("FETCH_LOADING", true);
      } else {
        visiableOkButtonOnModal(true);
      }

      let dto = {
        id: context.state.carIdEdit ? context.state.carIdEdit : null,
        accountant_id: context.carManagement.state.accountant_id,
        branch_id: values.area_management,
        chassis_no: values.chassis_no.trim(),
        color: values.color.trim(),
        engine_no: values.machine_id.trim(),
        fuel_type_group_id: values.fuel_type_code,
        insurance_expiry_date: values.ensurrance_expiry_date
          ? values.ensurrance_expiry_date.startOf("day").valueOf()
          : null,
        insurance_no: values.insurrance_nummber
          ? values.insurrance_nummber.trim()
          : null,
        liquidation_date: values.liquidation_date
          ? values.liquidation_date.startOf("day").valueOf()
          : null,
        model: values.model.trim(),
        note: values.note ? values.note.trim() : null,
        number_plate: values.number_plate,
        number_seat: values.number_seat,
        operation_admin_id: context.carManagement.state.operation_admin_id,
        owner: values.owner.trim(),
        place_of_origin: values.origin.trim(),
        registration_no: values.registry_id ? values.registry_id.trim() : null,
        registration_to_date: values.next_registry_date
          ? values.next_registry_date.startOf("day").valueOf()
          : null,
        road_fee_expiry_date: values.road_toll_expiry_date
          ? values.road_toll_expiry_date.startOf("day").valueOf()
          : null,
        start_using_date: values.start_using_date
          ? values.start_using_date.startOf("day").valueOf()
          : null,
        status:
          values.car_status === "KTDD"
            ? CAR_STATUS.KTDD
            : values.car_status === "CDD"
            ? CAR_STATUS.CDD
            : CAR_STATUS.DDD,
        transmission_type:
          values.classify_car === "MT"
            ? TRANSMISSION_TYPE.MT
            : TRANSMISSION_TYPE.AT,
        travel_warrant_expiry_date: values.license_expiry_date
          ? values.license_expiry_date.startOf("day").valueOf()
          : null,
        type: values.type_car.trim(),
        unit_operator_id: context.carManagement.state.unit_operator_id,
        vehicle_supplier_group_id: values.car_resource,
        year_manufacture: values.manufacture_year,
      };
      if (context.state.typeOption === "create_new") {
        try {
          const result = await apiVehicle.createNewCar(dto);
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
          if (result.status === "success") {
            if (isModal) {
              setCustomerOnModal(result.data);
            }
            alert("success", "Cập nhật xe thành công!");
            context.props.close && context.props.close();
          } else {
            alert("error", result.data.message);
          }
        } catch (error) {
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
        }
      } else {
        try {
          const result = await apiVehicle.updateCar(dto);
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
          if (result.status === "success") {
            if (isModal) {
              setCustomerOnModal(result.data);
            }
            alert("success", "Cập nhật xe thành công!");
            context.props.close && context.props.close();
          } else {
            alert("error", result.data.message);
          }
        } catch (error) {
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
        }
      }
    })
    .catch((err) => {});
};

export const carConvert = async (car, context) => {
  context.carManagement.setState({
    unit_operator_id: car.unit_operator_id ? car.unit_operator_id.id : null,
    accountant_id: car.accountant_id ? car.accountant_id.id : null,
    operation_admin_id: car.operation_admin_id
      ? car.operation_admin_id.id
      : null,
  });
  context.form.setFieldsValue({
    accountant: car.accountant_id ? car.accountant_id.name : null,
    area_management: car.branch_id ? car.branch_id.id : null,
    chassis_no: car.chassis_no ? car.chassis_no : null,
    color: car.color ? car.color : null,
    machine_id: car.engine_no ? car.engine_no : null,
    fuel_type_code: car.fuel_type_group_id.id
      ? car.fuel_type_group_id.id
      : null,
    ensurrance_expiry_date: car.insurance_expiry_date
      ? moment(car.insurance_expiry_date)
      : null,
    insurrance_nummber: car.insurance_no ? car.insurance_no : null,
    liquidation_date: car.liquidation_date
      ? moment(car.liquidation_date)
      : null,
    model: car.model ? car.model : null,
    note: car.note ? car.note : "",
    number_plate: car.number_plate ? car.number_plate : null,
    number_seat: car.number_seat ? car.number_seat : null,
    operation_admin: car.operation_admin_id
      ? car.operation_admin_id.name
      : null,
    owner: car.owner ? car.owner : null,
    origin: car.place_of_origin ? car.place_of_origin : null,
    registry_id: car.registration_no ? car.registration_no : null,
    next_registry_date: car.registration_to_date
      ? moment(car.registration_to_date)
      : null,
    road_toll_expiry_date: car.road_fee_expiry_date
      ? moment(car.road_fee_expiry_date)
      : null,
    start_using_date: car.start_using_date
      ? moment(car.start_using_date)
      : null,
    car_status:
      car.status === CAR_STATUS.KTDD
        ? "KTDD"
        : car.status === CAR_STATUS.CDD
        ? "CDD"
        : "DDD",
    classify_car: car.transmission_type
      ? car.transmission_type === TRANSMISSION_TYPE.MT
        ? "MT"
        : "AT"
      : null,
    license_expiry_date: car.travel_warrant_expiry_date
      ? car.travel_warrant_expiry_date
        ? moment(car.travel_warrant_expiry_date)
        : null
      : null,
    type_car: car.type ? car.type : null,
    unit_operator: car.unit_operator_id ? car.unit_operator_id.name : null,
    car_resource: car.vehicle_supplier_group_id.id
      ? car.vehicle_supplier_group_id.id
      : null,
    manufacture_year: car.year_manufacture ? car.year_manufacture : null,
  });
};
